module.exports = __webpack_public_path__ + "static/media/logo_reports_historico_azul.b9165533.png";